'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _d3Scale = require('d3-scale');

exports.default = function (_ref) {
  var range = _ref.range,
      domain = _ref.domain,
      unknown = _ref.unknown;

  var scale = (0, _d3Scale.scaleOrdinal)();

  if (range) scale.range(range);
  if (domain) scale.domain(domain);
  if (unknown) scale.unknown(unknown);

  return scale;
};


//////////////////
// WEBPACK FOOTER
// ./~/@vx/scale/build/scales/ordinal.js
// module id = ./node_modules/@vx/scale/build/scales/ordinal.js
// module chunks = 2345137460201621000 9249036036638527000 16304781003358073000